module.exports = __webpack_public_path__ + "img/l_hq.0bba6c1e.png";